// extracted by mini-css-extract-plugin
export default {"markdown-wrapper":"Markdown_markdown-wrapper__eVi78"};